import Navbar from "../components/Navbar";
import { Process } from "../components/Sections";
import { Footer } from "../components/Footer";
import Trust from "../components/Trust";
import Contact from "../components/Contact";

export default function ProcessPage() {
  return (
    <>
      <Navbar />
      <Process />
      <Contact/>
      <Footer />
      
    </>
  );
}